import { inject } from 'vue';
import { routerKey } from 'vue-router';

// Going back from a page a person reached from the shell.
//
// It asks the ROUTER what there is to pop, not the browser. vue-router records
// the previous entry in its own history state, which is empty exactly when
// there is nothing of the application's behind this page — a person who opened
// the page's address directly. A bare `router.back()` would do nothing at all
// there, so the page goes to the app's front door instead and back never
// dead-ends.
//
// @hds/identity-and-authentication-ui-lib holds the same few lines for its own
// pages: that package's targets export screens, not helpers.
//
// The router is read with `inject` rather than `useRouter()`, which warns when
// there is none. A page shown on its own in a Storybook has none, and its back
// arrow then does nothing.
//
// `home` is where "nothing to pop" lands — the app's front door by default, or
// the tab a page hangs off. Exported from the `./mobile` target so an app's own
// pushed pages ask the same question the shell's do (the phone portal's
// `useGoBack` keeps only its left-edge swipe and calls this for the decision).
function useBackOrHome({ home = '/' } = {}) {
    const router = inject(routerKey, null);
    return function goBack() {
        if (!router) {
            return;
        }
        if (router.options?.history?.state?.back) {
            router.back();
            return;
        }
        router.push(home);
    };
}

export { useBackOrHome };
